import React from 'react';
import PropTypes from 'prop-types';
import DataTableWidget from '../../../../common/components/DataTableWidget';
import PageContainer from '../../../../common/components/PageContainer';
import StatisticsPopup from '../StatisticsPopup';
import {formattingPrice} from '../../../../common/utils/formatting';
import styles from './styles.module.scss';

const columns = [
  {
    Header: '#',
    accessor: 'firmShumaID', // accessor is the "key" in the data
  },
  {
    Header: 'כתובת',
    accessor: 'address', // accessor is the "key" in the data
  },
  {
    Header: 'גוש וחלקה',
    accessor: 'gushAndHelka',
  },
  {
    Header: 'המועד הקובע',
    accessor: 'officialDate',
  },
  {
    Header: 'מטרת וסוג הדו"ח',
    accessor: 'shumaTypeName',
  },
  {
    Header: 'אומדן שווי',
    accessor: 'estimatePriceFinal',
  },
  {
    Header: ' ',
    accessor: 'actions',
  },
];

const InspectedDatabasePage = ({
                                 list,
                                 statistics,
                                 page,
                                 setPage,
                                 getListByShared,
                                 totalPages,
                                 totalResultCount
                               }) => {
  const preparedList = list && list.map(item => {
    const {estimatePriceFinal, ...rest} = item;
    const formattedPrice = estimatePriceFinal
      ? parseInt(estimatePriceFinal).toLocaleString()
      : '';

    return {
      estimatePriceFinal: formattedPrice,
      ...rest,
    };

  })

  const avgPrice = statistics && statistics.avgPrice ? formattingPrice(statistics.avgPrice) : '0';
  const maxPrice = statistics && statistics.maxPrice ? formattingPrice(statistics.maxPrice) : '0';
  const minPrice = statistics && statistics.minPrice ? formattingPrice(statistics.minPrice) : '0';

  return (
    <PageContainer>
      <div className={styles.inspectedDatabasePageContainer}>
        <DataTableWidget
          module={'InspectedDatabase'}
          title={'מאגר מידע שיתופי'}
          getListHandler={getListByShared}
          data={preparedList}
          columns={columns}
          page={page}
          setPage={setPage}
          totalPages={totalPages}
          totalResults={totalResultCount}
          customTableClassNames={{headerCell: styles.headerCell}}
          ActionButtonComponent={StatisticsPopup}
          allowSearchByCustomerName={false}
        />
        <div className={styles.infoContainer}>
          <div className={styles.infoItem}>
            <div className={styles.labelContainer}>שווי רף עליון</div>
            <div className={styles.inputContainer}>{maxPrice}</div>
          </div>
          <div className={styles.infoItem}>
            <div className={styles.labelContainer}>שווי רף תחתון</div>
            <div className={styles.inputContainer}>{minPrice}</div>
          </div>
          <div className={styles.infoItem}>
            <div className={styles.labelContainer}>שווי ממוצע</div>
            <div className={styles.inputContainer}>{avgPrice}</div>
          </div>
        </div>
      </div>
    </PageContainer>
  );
};

InspectedDatabasePage.propTypes = {
  list: PropTypes.array,
  page: PropTypes.number,
  setPage: PropTypes.func,
  getListByUser: PropTypes.func
};

export default InspectedDatabasePage;

